import { Component, OnDestroy, OnInit } from '@angular/core';
import { CacheService, ParameterHandlerService } from 'projects/common/src/app/services';
import { ITableView } from 'src/app/modules/core/interfaces';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';
import { CommunicationService } from 'src/app/services/communication';
import { DashboardWidgetBasicComponent } from '../dashboard-widget-basic/dashboard-widget-basic.component';

@Component({
  selector: 'app-dashboard-widget-table',
  templateUrl: './dashboard-widget-table.component.html',
  styleUrls: ['./dashboard-widget-table.component.scss'],
})
export class DashboardWidgetTableComponent extends DashboardWidgetBasicComponent implements OnInit, OnDestroy {
  public tableView: ITableView;

  constructor(
    protected progressBarService: BooleanStateService,
    protected communication: CommunicationService,
    protected parameterService: ParameterHandlerService,
    protected cacheService: CacheService,
    protected machineContext: MachineContextService,
    protected screenViewService: ScreenViewService,
  ) {
    super(progressBarService, communication, parameterService, cacheService, machineContext, screenViewService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected buildView(data: any): void {
    super.buildView(data);
    this.drawView(data);
  }

  protected drawView(data: any): void {
    this.hasData = data && data.dataset;
    this.tableView = data;
  }

  /**
   * On destroy component
   */
  public onDestroy(): void {
    super.ngOnDestroy();
  }
}
